import i18n from "i18next";

import { HazardIdEnum, LocationRiskAssessment, PageTabs, PolicyDetails } from "../hazardIdEnum";
import { userHasSomePermissions } from "./../../util/permissionsUtils";
import { cocoColorRange } from "../../util/colors";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

const getCommonHazardConfig = (label: string) => ({
  colorRange: cocoColorRange,
  pages: [PolicyDetails, LocationRiskAssessment] as Page[],
  label,
  name: label,
});

const getSeismicCocoHazardsList_new = () => {
  const seismicArr = [] as Hazard[];

  const seismicCoco3ITA = {
    cysId: HazardIdEnum.SeismicCoCo3Ita,
    permissions: [PermissionIdEnum.SeismicCoCo3Ita],
    description: i18n.t("riskExposureMapExplained.cocoT3"),
    ...getCommonHazardConfig("Seismic Coco 3 ITA"),
  };

  const seismicCoco3RMA = {
    cysId: HazardIdEnum.SeismicCoCo3Rma,
    permissions: [PermissionIdEnum.SeismicCoCo3Rma],
    description: i18n.t("riskExposureMapExplained.cocoT3"),
    ...getCommonHazardConfig("Seismic Coco 3 RMA"),
  };

  if (
    userHasSomePermissions([
      PermissionIdEnum.Super,
      PermissionIdEnum.SeismicCoCo4Ita,
      PermissionIdEnum.SeismicCoCo4Rma,
    ])
  ) {
    seismicArr.push(
      {
        cysId: HazardIdEnum.SeismicCoCo4Ita,
        permissions: [PermissionIdEnum.SeismicCoCo4Ita],
        description: i18n.t("riskExposureMapExplained.cocoT4"),
        pageTab: PageTabs.cocoNewTab,
        ...getCommonHazardConfig("Seismic Coco 4 ITA"),
      },
      {
        cysId: HazardIdEnum.SeismicCoCo4Rma,
        permissions: [PermissionIdEnum.SeismicCoCo4Rma],
        description: i18n.t("riskExposureMapExplained.cocoT4"),
        pageTab: PageTabs.cocoNewTab,
        ...getCommonHazardConfig("Seismic Coco 4 RMA"),
      },
      { ...seismicCoco3ITA, pageTab: PageTabs.cocoOldTab },
      { ...seismicCoco3RMA, pageTab: PageTabs.cocoOldTab },
    );
  } else {
    seismicArr.push(
      { ...seismicCoco3ITA, pageTab: PageTabs.cocoNewTab },
      { ...seismicCoco3RMA, pageTab: PageTabs.cocoNewTab },
      {
        cysId: HazardIdEnum.SeismicCoCo2Ita,
        permissions: [PermissionIdEnum.SeismicCoCo2Ita],
        description: i18n.t("riskExposureMapExplained.cocoT2"),
        pageTab: PageTabs.cocoOldTab,
        ...getCommonHazardConfig("Seismic Coco 2 ITA"),
      },
      {
        cysId: HazardIdEnum.SeismicCoCo2Rma,
        permissions: [PermissionIdEnum.SeismicCoCo2Rma],
        description: i18n.t("riskExposureMapExplained.cocoT2"),
        pageTab: PageTabs.cocoOldTab,
        ...getCommonHazardConfig("Seismic Coco 2 RMA"),
      },
    );
  }
  return seismicArr;
};

const getFloodCocoHazardsList_new = () => {
  const floodArr = [] as Hazard[];

  const floodCoco2Ita = {
    cysId: HazardIdEnum.FloodCoCo2Ita,
    permissions: [PermissionIdEnum.FloodCoCo2Ita],
    description: i18n.t("riskExposureMapExplained.cocoA2"),
    ...getCommonHazardConfig("Flood Coco 2 ITA"),
  };

  const floodCoco2Rma = {
    cysId: HazardIdEnum.FloodCoCo2Rma,
    permissions: [PermissionIdEnum.FloodCoCo2Rma],
    description: i18n.t("riskExposureMapExplained.cocoA2"),
    ...getCommonHazardConfig("Flood Coco 2 RMA"),
  };

  if (
    userHasSomePermissions([
      PermissionIdEnum.Super,
      PermissionIdEnum.FloodCoCo3Ita,
      PermissionIdEnum.FloodCoCo3Rma,
    ])
  ) {
    floodArr.push(
      {
        cysId: HazardIdEnum.FloodCoCo3Ita,
        permissions: [PermissionIdEnum.FloodCoCo3Ita],
        description: i18n.t("riskExposureMapExplained.cocoA3"),
        pageTab: PageTabs.cocoNewTab,
        ...getCommonHazardConfig("Flood Coco 3 ITA"),
      },
      {
        cysId: HazardIdEnum.FloodCoCo3Rma,
        permissions: [PermissionIdEnum.FloodCoCo3Rma],
        description: i18n.t("riskExposureMapExplained.cocoA3"),
        pageTab: PageTabs.cocoNewTab,
        ...getCommonHazardConfig("Flood Coco 3 RMA"),
      },
      { ...floodCoco2Ita, pageTab: PageTabs.cocoOldTab },
      { ...floodCoco2Rma, pageTab: PageTabs.cocoOldTab },
    );
  } else {
    floodArr.push(
      { ...floodCoco2Ita, pageTab: PageTabs.cocoNewTab },
      { ...floodCoco2Rma, pageTab: PageTabs.cocoNewTab },
      {
        cysId: HazardIdEnum.FloodCoCoIta,
        permissions: [PermissionIdEnum.FloodCoCoIta],
        description: i18n.t("riskExposureMapExplained.cocoA"),
        pageTab: PageTabs.cocoOldTab,
        ...getCommonHazardConfig("Flood Coco ITA"),
      },
      {
        cysId: HazardIdEnum.FloodCoCoRma,
        permissions: [PermissionIdEnum.FloodCoCoRma],
        description: i18n.t("riskExposureMapExplained.cocoA"),
        pageTab: PageTabs.cocoOldTab,
        ...getCommonHazardConfig("Flood Coco RMA"),
      },
    );
  }

  return floodArr;
};

const getLandslideCocoHazardsList_new = () => {
  const landslideArr = [] as Hazard[];

  const landslideCoco2Ita = {
    cysId: HazardIdEnum.LandslideCoCo2Ita,
    permissions: [PermissionIdEnum.LandslideCoCo2Ita],
    description: i18n.t("riskExposureMapExplained.cocoF2"),
    ...getCommonHazardConfig("Landslide Coco 2 ITA"),
  };

  const landslideCoco2Rma = {
    cysId: HazardIdEnum.LandslideCoCo2Rma,
    permissions: [PermissionIdEnum.LandslideCoCo2Rma],
    description: i18n.t("riskExposureMapExplained.cocoF2"),
    ...getCommonHazardConfig("Landslide Coco 2 RMA"),
  };

  if (
    userHasSomePermissions([
      PermissionIdEnum.Super,
      PermissionIdEnum.LandslideCoCo3Ita,
      PermissionIdEnum.LandslideCoCo3Rma,
    ])
  ) {
    landslideArr.push(
      {
        cysId: HazardIdEnum.LandslideCoCo3Ita,
        permissions: [PermissionIdEnum.LandslideCoCo3Ita],
        description: i18n.t("riskExposureMapExplained.cocoF3"),
        pageTab: PageTabs.cocoNewTab,
        ...getCommonHazardConfig("Landslide Coco 3 ITA"),
      },
      {
        cysId: HazardIdEnum.LandslideCoCo3Rma,
        permissions: [PermissionIdEnum.LandslideCoCo3Rma],
        description: i18n.t("riskExposureMapExplained.cocoF3"),
        pageTab: PageTabs.cocoNewTab,
        ...getCommonHazardConfig("Landslide Coco 3 RMA"),
      },
      { ...landslideCoco2Ita, pageTab: PageTabs.cocoOldTab },
      { ...landslideCoco2Rma, pageTab: PageTabs.cocoOldTab },
    );
  } else {
    landslideArr.push(
      { ...landslideCoco2Ita, pageTab: PageTabs.cocoNewTab },
      { ...landslideCoco2Rma, pageTab: PageTabs.cocoNewTab },
      {
        cysId: HazardIdEnum.LandslideCoCoIta,
        permissions: [PermissionIdEnum.LandslideCoCoIta],
        description: i18n.t("riskExposureMapExplained.cocoF"),
        pageTab: PageTabs.cocoOldTab,
        ...getCommonHazardConfig("Landslide Coco ITA"),
      },
      {
        cysId: HazardIdEnum.LandslideCoCoRma,
        permissions: [PermissionIdEnum.LandslideCoCoRma],
        description: i18n.t("riskExposureMapExplained.cocoF"),
        pageTab: PageTabs.cocoOldTab,
        ...getCommonHazardConfig("Landslide Coco RMA"),
      },
    );
  }

  return landslideArr;
};

const shared = (label: string) => ({
  colorRange: cocoColorRange,
  pages: [PolicyDetails, LocationRiskAssessment] as Page[],
  label,
  name: label,
});

const pushPair = (
  list: Hazard[],
  version: string,
  infix: string,
  enumIta: HazardIdEnum,
  enumRma: HazardIdEnum,
  hazardExtras: any,
) => {
  list.push(
    {
      ...shared(`${version} ${infix} ITA`),
      cysId: enumIta,
      ...hazardExtras,
    },
    {
      ...shared(`${version} ${infix} RMA`),
      cysId: enumRma,
      ...hazardExtras,
    },
  );
};

const getSeismicCocoHazardsList = (): Hazard[] => {
  const list: Hazard[] = [];
  if (userHasSomePermissions(["super", "CYS_RISK_COCO_CCT4"])) {
    const newTab = {
      permissions: ["CYS_RISK_COCO_CCT4"],
      description: i18n.t("riskExposureMapExplained.cocoT4"),
      pageTab: PageTabs.cocoNewTab,
    };
    const oldTab = {
      permissions: ["CYS_RISK_COCO_CCT4"],
      description: i18n.t("riskExposureMapExplained.cocoT3"),
      pageTab: PageTabs.cocoOldTab,
    };

    pushPair(list, "Seismic", "Coco 4", HazardIdEnum.SeismicCoCo4Ita, HazardIdEnum.SeismicCoCo4Rma, newTab);
    pushPair(list, "Seismic", "Coco 3", HazardIdEnum.SeismicCoCo3Ita, HazardIdEnum.SeismicCoCo3Rma, oldTab);
  } else if (userHasSomePermissions(["CYS_RISK_COCO_CCT3"])) {
    const newTab = {
      permissions: ["CYS_RISK_COCO_CCT3"],
      description: i18n.t("riskExposureMapExplained.cocoT3"),
      pageTab: PageTabs.cocoNewTab,
    };
    const oldTab = {
      permissions: ["CYS_RISK_COCO_CCT3"],
      description: i18n.t("riskExposureMapExplained.cocoT2"),
      pageTab: PageTabs.cocoOldTab,
    };
    pushPair(list, "Seismic", "Coco 3", HazardIdEnum.SeismicCoCo3Ita, HazardIdEnum.SeismicCoCo3Rma, newTab);
    pushPair(list, "Seismic", "Coco 2", HazardIdEnum.SeismicCoCo2Ita, HazardIdEnum.SeismicCoCo2Rma, oldTab);
  }

  return list;
};

const getFloodCocoHazardsList = (): Hazard[] => {
  const list: Hazard[] = [];
  if (userHasSomePermissions(["super", "CYS_RISK_COCO_CCA3"])) {
    const newTab = {
      permissions: ["CYS_RISK_COCO_CCA3"],
      description: i18n.t("riskExposureMapExplained.cocoA3"),
      pageTab: PageTabs.cocoNewTab,
    };
    const oldTab = {
      permissions: ["CYS_RISK_COCO_CCA3"],
      description: i18n.t("riskExposureMapExplained.cocoA2"),
      pageTab: PageTabs.cocoOldTab,
    };

    pushPair(list, "Flood", "Coco 3", HazardIdEnum.FloodCoCo3Ita, HazardIdEnum.FloodCoCo3Rma, newTab);
    pushPair(list, "Flood", "Coco 2", HazardIdEnum.FloodCoCo2Ita, HazardIdEnum.FloodCoCo2Rma, oldTab);
  } else if (userHasSomePermissions(["CYS_RISK_COCO_CCA2"])) {
    const newTab = {
      permissions: ["CYS_RISK_COCO_CCA2"],
      description: i18n.t("riskExposureMapExplained.cocoA2"),
      pageTab: PageTabs.cocoNewTab,
    };
    const oldTab = {
      permissions: ["CYS_RISK_COCO_CCA2"],
      description: i18n.t("riskExposureMapExplained.cocoA"),
      pageTab: PageTabs.cocoOldTab,
    };
    pushPair(list, "Flood", "Coco 2", HazardIdEnum.FloodCoCo2Ita, HazardIdEnum.FloodCoCo2Rma, newTab);
    pushPair(list, "Flood", "Coco", HazardIdEnum.FloodCoCoIta, HazardIdEnum.FloodCoCoRma, oldTab);
  }

  return list;
};

const getLandslideCocoHazardsList = (): Hazard[] => {
  const list: Hazard[] = [];
  if (userHasSomePermissions(["super", "CYS_RISK_COCO_CCF3"])) {
    const newTab = {
      permissions: ["CYS_RISK_COCO_CCF3"],
      description: i18n.t("riskExposureMapExplained.cocoF3"),
      pageTab: PageTabs.cocoNewTab,
    };

    const oldTab = {
      permissions: ["CYS_RISK_COCO_CCF3"],
      description: i18n.t("riskExposureMapExplained.cocoF2"),
      pageTab: PageTabs.cocoOldTab,
    };
    // prettier-ignore
    pushPair(list, "Landslide", "Coco 3", HazardIdEnum.LandslideCoCo3Ita, HazardIdEnum.LandslideCoCo3Rma, newTab);
    pushPair(list, "Landslide", "Coco 2", HazardIdEnum.LandslideCoCo2Ita, HazardIdEnum.LandslideCoCo2Rma, oldTab);
    // prettier-ignore
    // prettier-ignore-end
  } else if (userHasSomePermissions(["CYS_RISK_COCO_CCF2"])) {
    const newTab = {
      permissions: ["CYS_RISK_COCO_CCF2"],
      description: i18n.t("riskExposureMapExplained.cocoF2"),
      pageTab: PageTabs.cocoNewTab,
    };
    const oldTab = {
      permissions: ["CYS_RISK_COCO_CCF2"],
      description: i18n.t("riskExposureMapExplained.cocoF"),
      pageTab: PageTabs.cocoOldTab,
    };
    // prettier-ignore
    pushPair(list, "Landslide", "Coco 2", HazardIdEnum.LandslideCoCo2Ita, HazardIdEnum.LandslideCoCo2Rma, newTab);
    pushPair(list, "Landslide", "Coco", HazardIdEnum.LandslideCoCoIta, HazardIdEnum.LandslideCoCoRma, oldTab);
    // prettier-ignore-end
  }

  return list;
};

export const getAllCocoHazardsList = (): Hazard[] => [
  ...getSeismicCocoHazardsList(),
  ...getFloodCocoHazardsList(),
  ...getLandslideCocoHazardsList(),
];
